
import { callServer } from 'next/dist/client/app-call-server'

function __build_action__(action, args) {
  return callServer(action.$$id, args)
}

/* __next_internal_action_entry_do_not_use__ {"3ff78bb6589f3da325e13ce5215a534de0d488b9":"MainLayout"} */ export var MainLayout = createServerReference("3ff78bb6589f3da325e13ce5215a534de0d488b9");
import { createServerReference } from "private-next-rsc-action-client-wrapper";

